import { useEffect } from 'react';
import { notificationService } from '../services/notificationService';
import { useAppSelector } from './reduxHooks';
import type { SLAAlertPayload } from '../services/slaService';

export interface AlertNotification {
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
}

export function useAlertNotifications(
  onAlert: (alert: AlertNotification) => void,
  enabled: boolean = true,
) {
  const token = useAppSelector((state) => state.auth.token);

  useEffect(() => {
    if (!enabled || !token) {
      return;
    }
    notificationService.connect();
    const unsubscribe = notificationService.subscribe((payload) => {
      if (payload.type === 'sla_refresh') return;
      if (payload.type !== 'system_alert') return;
      const alert = payload as unknown as SLAAlertPayload;
      const severityMap: Record<string, AlertNotification['severity']> = {
        critical: 'error',
        warning: 'warning',
        resolved: 'success',
      };
      const sev = severityMap[alert.severity] ?? 'info';
      onAlert({
        message: `${alert.module}/${alert.service}: ${alert.message}`,
        severity: sev,
      });
    });
    return () => {
      unsubscribe();
      notificationService.disconnect();
    };
  }, [onAlert, token, enabled]);
}
